import { useState, useEffect } from "react";
import AdminLayout from "./AdminLayout";
import ManagementPermissions from "../ui/ManagementPermissions";
import EmployeePermissions from "../ui/EmployeePermissions";
import { useUser, useGetPermissions } from "../Use-auth";
import HrPermissions from "../ui/HrPermissions";
import PermissionPopup from "../ui/PermissionPopup";

export default function Setting() {
    const { data: user } = useUser();
    const { data: existingPermissions, refetch } = useGetPermissions();

    const isAdmin = user?.department === "Admin";
    const currentUserPermissions = isAdmin
        ? { management: { management_edit: true } }
        : existingPermissions?.find((p) => p.userId === user?.userId);

    const canViewUpdate = isAdmin || currentUserPermissions?.management?.management_edit;

    const isManager = user?.department === "Management";

    const [activeTab, setActiveTab] = useState(
        isManager ? "employees" : "management"
    );

    useEffect(() => {
        if (isManager) {
            setActiveTab("employees");
        }
    }, [isManager]);

    return (
        <AdminLayout>
            <div className="relative  bg-gray-50 overflow-hidden z-1">

                <div className="relative z-1 h-full overflow-y-auto p-2 rs:p-6">
                    <h3 className="text-[14px] sm:text-[16px] md:text-[20px] font-semibold text-gray-800 mb-6">
                        Permissions
                    </h3>
                    <div className="flex border-b border-gray-300 mb-6">
                        {!isManager && (
                            <div
                                className={`px-4 py-2 text-[12px] lg:text-sm font-medium rounded-t-lg transition cursor-pointer
                                ${activeTab === "management"
                                        ? "bg-blue-50 text-blue-600 border-b-2 border-blue-600"
                                        : "text-gray-600 hover:text-blue-600"
                                    }`}
                                onClick={() => setActiveTab("management")}
                            >
                                Management
                            </div>
                        )}

                        <div
                            className={`ml-2 px-4 py-2 text-[12px] lg:text-sm font-medium  rounded-t-lg transition cursor-pointer
                            ${activeTab === "employees"
                                    ? "bg-blue-50 text-blue-600 border-b-2 border-blue-600"
                                    : "text-gray-600 hover:text-blue-600"
                                }`}
                            onClick={() => setActiveTab("employees")}
                        >
                            Employees
                        </div>

                        {!isManager && (<div
                            className={`ml-2 px-4 py-2 font-medium text-[12px] lg:text-sm rounded-t-lg transition cursor-pointer
                            ${activeTab === "hr"
                                    ? "bg-blue-50 text-blue-600 border-b-2 border-blue-600"
                                    : "text-gray-600 hover:text-blue-600"
                                }`}
                            onClick={() => setActiveTab("hr")}
                        >
                            HR
                        </div>)}
                        {/* {canViewUpdate && (
                            <div
                                className={`ml-2 px-4 py-2 font-medium text-sm rounded-t-lg transition cursor-pointer
                                ${activeTab === "employees_data"
                                        ? "bg-white border border-b-0 border-gray-300 text-blue-600"
                                        : "text-gray-600 hover:text-blue-600"
                                    }`}
                                onClick={() => setActiveTab("employees_data")}
                            >
                                Employees Data
                            </div>
                        )} */}
                    </div>

                    {/* Tab Content */}
                    <div className="bg-white border border-gray-300 rounded-b-lg p-2 sm:p-6 min-h-[300px] rounded-lg">

                        {!isManager && activeTab === "management" && (
                            <ManagementPermissions adminId={user.username} />
                        )}

                        {canViewUpdate && activeTab === "employees" && (
                            <EmployeePermissions adminId={user.username} />
                        )}

                        {!canViewUpdate && activeTab === "employees" && (
                            <PermissionPopup />
                        )}

                        {activeTab === "hr" && (
                            <HrPermissions adminId={user.username} />
                        )}

                        {/* {activeTab === "employees_data" && (
                            <EmployessData
                                totalStaff={totalStaff}
                                deleteUser={deleteUser}
                                editUser={editUser}
                                user={user}
                            />
                        )} */}
                    </div>

                </div>
            </div>
        </AdminLayout>
    );
}
